import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"

const SmartLink = ({ to, href, className, children, ...rest }) => {
  const target = to || href

  const isExternal =
    target &&
    (target.startsWith("http://") ||
      target.startsWith("https://") ||
      target.startsWith("mailto:"))

  let filteredProps = {}
  Object.keys(rest)
    .filter((key) => key !== "styleModifier")
    .map((key) => (filteredProps[key] = rest[key]))

  return isExternal ? (
    <a
      href={target}
      className={className}
      target="_blank"
      rel="noreferrer"
      {...filteredProps}
    >
      {children}
    </a>
  ) : (
    <Link to={target} className={className} {...filteredProps}>
      {children}
    </Link>
  )
}

export default styled(SmartLink)``
